const TRANSLATIONS_RU = {
  buttons: {
    transits: 'Транзиты',
    customers: 'Клиенты',
    settings: 'Настройки',
    duplicate: 'Копировать',
    createTransitFromEns: 'Создать транзит из ENS',
    viewLogs: '$t(common.view) логи',
    viewLogs_close: '$t(buttons.close) логи',
    reassignOwner: 'Переназначить владельца',
    delete: 'Удалить',
    profile: 'Профиль',
    logOut: 'Выход',
    logIn: 'Войти',
    register: 'Pегистр',
    startPasswordRecovery: 'Забыли логин/пароль?',
    resetPassword: 'Сбросить пароль',
    useDefault: 'Использовать стандарт',
    recoveryEmail: 'Восстановить пароль на почту',
    backToLogin: 'Вернуться для входа',
    regenerate: 'Сгенерировать заново',
    addFiles: 'Добавить файл',
    remove: 'Удалить',
    addNew: 'Добавить',
    addNewExternal: 'Добавить (directo)',
    addGoods: 'Добавить товар',
    addUser: 'Добавить пользователя',
    addProfile: 'Добавить гарантийный профиль',
    saveGoods: 'Сохранить',
    saveDraft: 'Сохранить как черновик',
    save: 'Сохранить',
    done: 'Готово',
    send: 'Отправить',
    submitCustoms: 'в таможню',
    submitReview: 'для обзора',
    amendmentCustoms: 'Редактировать',
    cancelCustoms: 'Отменить',
    customs: 'Таможня',
    confirm: 'Подтвердить',
    submit: 'Предоставить',
    createNew: 'Создавать новое',
    amend: 'Изменять',
    summary: 'Краткое содержание',
    cancel: 'Отменить',
    change: 'Измененить',
    editDeclaration: '$t(buttons.change) декларацию',
    cancelDeclaration: '$t(buttons.cancel) декларацию',
    block: 'Блок',
    activate: 'Активировать',
    close: 'Закрыть',
    sendInvite: 'Отправить приглашение',
    rotate_left: '$t(common.rotate)  $t(common.left)',
    rotate_right: '$t(common.rotate) $t(common.right)',
    review_approved: 'Отметить как проверенное',
    review_decline: 'Снять отметку',
    decideAudit: 'Решить',
    decideAuditHeader: 'Определить статус декларации',
    signAndSubmit: 'Подписать и отправить',
    export: 'Экспорт',
    next: 'Следующий шаг',
    previous: 'Предыдущий шаг',
    activateUser: 'Активировать аккаунт',
    companyInfo: 'информация о компании',
    requestAccess: 'Запрос доступа',
    accept: 'Принять условия',
    feedback: 'Обратная связь',
    t1Closed: 'Изменить статус на Т1 Транзит закрыт',
    notes: 'Примечания',
    filter: 'Табличные фильтры',
    filter_clear: 'Очистить фильтры',
    downloadPdf: 'Скачать PDF',
    downloadXml: 'Скачать XML',
    downloadTaxesPdf: 'НАЛОГИ PDF',
    downloadTaxesXlsx: 'НАЛОГИ XLSX',
    generateXml: 'Загрузить форму заявки (IE015)',
    importRestriction: 'Ограничение на импорт',
    quickFiltersWithCount_zero: 'Быстрые фильтры',
    quickFiltersWithCount_one: 'Быстрые фильтры ({{count}})',
    quickFiltersWithCount_other: 'Быстрые фильтры ({{count}})',
    copyLink_guaranteeClaim: 'Копировать ссылку на гарантию',
    contact: 'Контакт',
    customsResponse: 'Ответ таможни (FI046A)',
    decideRelease: 'Решение о выпуске (IE054)',
    nonArrivedMovementRelease: 'Выпуск не прибывшего товара (IE141)',
    preLodgedDeclPresentationNotification: 'Уведомление о предъявлении (IE170)',
    ensPresentationNotification: 'Уведомление о презентации ENS',
  },
  notes: {
    title: 'Добавить примечание к декларации',
    submit: 'Отправить заметку',
    saveError: 'Не удалось обновить заметки',
  },
  calculator: {
    title: 'Калькулятор',
    insert: 'Вставить',
  },
  transit: {
    title: 'транзит',
    id: 'ID',
    mrnAndLrn: '$t(common.mrn)/$t(common.lrn)',
    consignor: 'Отправитель',
    consignee: 'Получатель',
    carrier: 'Перевозчик',
    transport: 'Транспорт',
    departureCustomsOffice: 'Код таможни отправления',
    destinationCustomsOffice: 'Код таможни назначения',
    customer: 'Клиент',
    status: 'Статус',
    createdByName: 'Создано',
    created: 'Создания',
    modified: 'Изменено',
    reviewed: 'Проверено',
    notReviewed: 'Не проверено',
    reviewer: 'Рецензент',
    lastReview: 'Последний отзыв',
    guaranteeAmount: 'Гарантии',
    directoStatus: '$t(declaration.headers.directoEvent) $t(transit.status)',
    directoClient: 'Directo клиент',
    declarationType: 'Тип декларации',
    additionalDeclarationType: 'Доп. тип',
    guaranteeClaimReservationStatus: 'Гарантии статус',
    security: 'Безопасность',
    specificCircumstanceIndicator: 'Спец. обст.',
  },
  common: {
    new: 'Новый',
    edit: 'Редактировать',
    view: 'Посмотреть',
    date: 'Дата',
    type: 'Тип',
    message: 'Сообщение',
    user: 'Пользователь',
    yes: 'Да',
    yes_entryIndicator: 'Да (1)',
    no: 'Нет',
    no_entryIndicator: 'Нет (0)',
    chooseCountry: 'Выберите страну',
    chooseField: 'Выберите поле',
    chooseProfile: 'Выбрать профиль',
    chooseGoodsItem: 'Выбрать товар',
    chooseMode: 'Выберите тип',
    fieldPlaceholder: 'Пожалуйста заполните форму',
    customsPlaceholder: 'Поиск таможни',
    name: 'имя',
    name_capitalized: 'Имя',
    typeToSearch: 'Введите для поиска {{0}} или добавить новый',
    loading: 'Загрузка…',
    saving: 'Сохранение…',
    street: 'Улица',
    streetNumber: 'Номер улицы',
    city: 'Город',
    zip: 'Индекс',
    grnCode: 'ГРН код',
    guaranteeType: 'Тип гарантии',
    value: 'Значение',
    select: 'Выбор',
    confirmAction: 'Подтвердить действие',
    confirmAction_confirm: 'Вы уверены, что хотите это сделать?',
    error: 'Ошибка!',
    email: 'Электронная почта',
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    phone: 'Телефон',
    mrn: 'MRN',
    ensMrn: 'ENS MRN',
    lrn: 'LRN',
    log: 'лог',
    rotate: 'Повернуть',
    left: 'налево',
    right: 'вправо',
    show: 'Показать',
    page: 'Страница',
    pageSeparator: 'из',
    goToPage: 'Перейти на страницу',
    userInformation: 'Информация об аккаунте',
    companyInformation: 'Информация о компании',
    registerSuccess: 'Вы успешно зарегистрировались',
    customsProfileName: 'Имя профиля',
    customsProfileAuthority: 'Офис власти',
    customsProfileCountry: 'Страна полномочий',
    safetyAndSecurityIdentificationNumber: 'Идентификационный номер безопасности (ENS)',
    safetyAndSecurityCountry: 'Страна идентификации безопасности (ENS)',
    customsProfileGrn: 'ГРН',
    submit_success: 'Отправка успешна!',
    submit_error: 'Отправка не удалась!',
    submit_exists: 'Представление уже существует!',
    submit_errorWithTraceId: 'Отправка не удалась! Trace id {{traceId}}',
    submit_errorWithErrorCode: 'Отправка не удалась! Error code {{traceId}}',
    submit_service_unavailable: 'Отправка ошибка! Возможные проблемы с национальной таможенной системой NCTS страны отправления. Повторите попытку позже!',
    submit_payload_too_large: 'Ошибка отправки! Заполненная форма слишком большая! Попробуйте уменьшить размер прикреплённых файлов и т.д.',
    clear: 'Очистить',
  },
  declaration: {
    navbar: {
      general: 'Общий',
      consignment: 'Суб-путевая накладная',
      house: 'Накладные',
      transitParties: 'Участники транзита',
      houseConsignments_zero: 'Накладная',
      houseConsignments: 'Накладная ({{count}})',
      goods: 'Товары',
      directo: 'Directo',
      summary: 'Краткое содержание',
      logs: 'Журналы событий',
      additional: 'Важная информация!',
    },
    headers: {
      info: 'Информация о транзите',
      declarationInfo: 'Инфо о декларации',
      goods: 'Товары',
      goodsItem: 'Кол-во товаров',
      traders: 'Отправители/Получатели',
      carrier: 'Перевозчик',
      transport: 'Транспорт',
      transportAndLoading: 'Транспорт и загрузка',
      metaData: 'Метаданные',
      goodsItems: 'Кол-во товаров',
      logs: 'Логи',
      validate: 'подтверждать',
      goodsInfo: 'Информация о товарах',
    },
    finnish: {
      geographical_location: 'Географическое положение',
      zip_code: 'Почтовый индекс',
      warehouse_identifier: 'Идентификатор склада',
      customs_office: 'Таможня',
      doubleTransportMode: 'Финская таможня принимает только однозначные виды транспорта',
      arexNumber: 'Номер заказа Арекс',
      transportDocumentId: 'Идентификатор транспортного документа',
      error: {
        transitDateLimit: 'Отсутствует ограничение по дате транзита',
        transitLoadingDate: 'Отсутствует дата погрузки транзита',
        transportDocument: 'Транспортный документ всегда должен быть задекларирован с первой партией товара.',
        transportDocumentLength: 'Длина номера транспортного документа может быть только от 1 до 20 символов.',
        previousDocumentMandatory: 'Предыдущие документы обязательны для финских деклараций! Если предыдущих документов нет, выберите Тип документа (40A) 00: Нет предыдущей процедуры и введите 00 в поле Номер документа (40B).',
      },
    },
    status: {
      draft: 'Черновик',
      rejected: 'Выброшенный',
      accepted: 'Принятый',
      confirmed: 'Представление подтверждено',
      open: 'Транзит открыт',
      declined: 'Отказывать',
      canceled: 'Отменено',
      ended: 'Транзит закончился',
      arrived: 'IE006 прибыл',
      t1Closed: 'Транзит T1 завершен',
      checkOk: 'Проверить не в порядке',
      control: 'Контрольное решение',
      discrepancies: 'Расхождения',
      cancelRequested: 'Запрошена отмена',
      goodsReleaseNotification: 'Уведомление о выпуске товара',
      nonArrivedMovement: 'Неприбывшее движение',
      nonArrivedMovementReleaseRequest: 'Освобождение от не прибывшего движения',
    },
    p5: {
      eori: 'ЕОРИ',
      sequenceNumber: '№',
      mrn: 'MRN',
      ensMrn: 'ENS MRN',
      lrn: 'LRN',
      name: 'Имя',
      declarationType: 'Тип объявления',
      security: 'Защитные данные',
      specificCircumstanceIndicator: 'Индикатор конкретных обстоятельств',
      additionalDeclarationType: 'Тип дополнительной декларации',
      bindingItinerary: 'Обязательный маршрут',
      entryIndicator: 'Индикатор входа',
      reEntryIndicator: 'Индикатор повторного входа',
      reducedDatasetIndicator: 'Уменьшенный набор данных',
      limitDate: 'Крайний срок',
      dispatchCountry: 'Страна отправления',
      departureCustomsOffice: 'Код таможни отправления',
      destinationCustomsOffice: 'Код таможни назначения',
      destinationCountry: 'Страна назначения',
      totalNumberOfPackages: 'Общее количество упаковок',
      multiPackagingNotEditable: 'У этой товарной позиции более одной упаковки. Пожалуйста, измените количество упаковок в форме сведений о товарной позиции.',
      quantity: 'Количество',
      grossWeight: 'Брутто вес',
      grossWeight_current: 'Текущий вес товара',
      containerisedIndicator: 'Товары в контейнерах',
      transportEquipment: 'Транспортное оборудование',
      containers: 'контейнеры',
      containerNumber: 'Идентификационный номер',
      addNewContainer: 'Добавить контейнер',
      seals: 'Морские котики',
      addNewSeal: 'Добавить печать',
      numberOfSeals: 'Количество пломб',
      sealIdentifier: 'Идентификатор печати',
      goodsReferences: 'Ссылки на товары',
      addNewGoodsReferences: 'Добавить ссылку на товар',
      declarationGoodsItemNumber: 'Товарные позиции №. в декларации',
      transport: 'Транспорт',
      borderTransportMode: 'Тип транспорта на границе',
      inlandTransportMode: 'Внутренний тип транспорта',
      departureTransportMeans: 'Транспортное средство отправления',
      typeOfIdentification: 'Тип идентификации транспортных средств',
      identificationNumber: 'Номер идентификации транспортного средства',
      typeOfMeansOfTransport: 'Вид транспортного средства',
      nationality: 'Страна',
      conveyanceReferenceNumber: 'Справочный номер транспортного средства',
      customsOfficeAtTheBorder: 'Таможня на границе',
      borderTransportMeans: 'Пограничные транспортные средства',
      addNewTransportMeans: 'Новые транспортные средства',
      placeOfLoading: 'Место загрузки',
      placeOfUnLoading: 'Место выгрузки',
      placeOfAcceptance: 'Место принятия',
      placeOfDelivery: 'Место доставки',
      locationOfGoods: 'Местоположение товара',
      typeOfLocation: 'Тип местоположения',
      locationOfGoodsReferenceNumber: 'Таможня',
      qualifierOfIdentification: 'Квалификатор идентификации',
      authorisations: 'Разрешения',
      addNewAuthorisation: 'Добавить авторизации',
      authorisationNumber: 'Номер авторизации',
      authorisationType: 'Тип авторизации',
      authorisationReferenceNumber: 'Справочный номер авторизации',
      additionalIdentifier: 'Дополнительный идентификатор',
      economicOperatorIdentificationNumber: 'Идентификационный номер экономического оператора (EORI)',
      unLocode: 'UN/LOCODE',
      placeOfLoadingLocation: 'расположение места погрузки',
      placeOfUnloadingLocation: 'расположение места разгрузки',
      placeOfAcceptanceLocation: 'Местонахождение места приемки',
      placeOfDeliveryLocation: 'Местонахождение места доставки',
      countriesOfRouting: 'Страны маршрута',
      countryOfRouting: 'Страна маршрутизации',
      addNewRoutingCountry: 'Добавить новую страну',
      customsOfficeOfTransit: 'Таможни транзита',
      transitExitCustomsOffices: 'Таможня транзитного выезда',
      referenceNumber: 'Справочный номер',
      arrivalDateAndTime: 'Дата и время прибытия',
      actualDateAndTimeOfDeparture: 'Фактическая дата и время отправления',
      estimatedDateAndTimeOfDeparture: 'Предполагаемая дата и время отправления',
      estimatedDateAndTimeOfArrival: 'Предполагаемая дата и время прибытия',
      addNewCustomsOfficeOfTransit: 'Новая таможня транзита',
      addNewCustomsOfficeOfExitForTransit: 'Новая выездная транзитная таможня',
      transportDocuments: 'Транспортные документы',
      transportDocuments_singular: 'Транспортные документ',
      transportDocumentType: 'Тип транспортного документа',
      transportDocumentReferenceNumber: 'Справочный номер транспортного документа',
      addNewDocument: 'Новый документ',
      previousDocuments: 'Предыдущие документы',
      previousDocuments_singular: 'Предыдущие документ',
      previousDocumentType: 'Тип документа',
      procedureType: 'Тип процедуры',
      previousDocumentReferenceNumber: 'Справочный номер',
      complementOfInformation: 'Дополнение информации',
      supportingDocuments: 'Подтверждающие документы',
      supportingDocuments_singular: 'Подтверждающие документ',
      supportingDocumentType: 'Тип документа',
      supportingDocumentReferenceNumber: 'Справочный номер',
      documentType: 'Тип документа',
      referenceType: 'Тип ссылки',
      type: 'Тип',
      code: 'Код',
      text: 'Текст',
      itemNumber: 'Номер предмета',
      additionalReferences: 'Дополнительные ссылки',
      additionalReferenceType: 'Тип ссылки',
      additionalReferenceNumber: 'Справочный номер',
      addNewReference: 'Новая ссылка',
      additionalInformations: 'Дополнительная информация',
      additionalInformationCode: 'Код дополнительной информации',
      additionalInformationText: 'Текст дополнительной информации',
      transitProcedureHolder: 'Держатель транзитной процедуры',
      procedureIdentificationNumber: 'Идентификационный номер',
      transitProcedureName: 'Имя',
      country: 'Страна',
      address: 'Адрес',
      street: 'Улица',
      addressLine: 'Адресная линия',
      streetNumber: 'Номер улицы',
      typeOfPerson: 'Тип человека',
      city: 'Город',
      postcode: 'Почтовый индекс',
      contactPersonName: 'Имя контактного лица',
      contactPersonEmail: 'Электронная почта контактного лица',
      contactPersonPhone: 'Телефон контактного лица',
      representative: 'Представитель',
      representativeIdentificationNr: 'Идентификационный номер представителя',
      representativeStatus: 'Представительский статус',
      guarantees: 'Гарантии',
      addNewGuarantee: 'Добавить новую гарантию',
      guaranteeType: 'Тип гарантии',
      guaranteeReference: 'Ссылка на гарантию',
      grn: 'Номер гарантии (GRN)',
      accessCode: 'Код доступа',
      amountToBeCovered: 'Сумма, подлежащая покрытию',
      currency: 'Валюта',
      consignor: 'Отправитель',
      consignorIdentificationNr: 'Идентификационный номер отправителя',
      consignorName: 'Имя отправитель',
      consignorCountry: 'Страна отправитель',
      consignee: 'Получатель',
      consigneeIdentificationNr: 'Идентификационный номер получатель',
      consigneeName: 'Имя получатель',
      consigneeCountry: 'Страна получатель',
      carrier: 'Перевозчик',
      carrierIdentificationNr: 'Идентификационный номер перевозчик',
      carrierName: 'Наименование перевозчика',
      declarant: 'Декларант',
      buyer: 'Покупатель',
      seller: 'Продавцом',
      additionalSupplyChainActor: 'Дополнительный участник цепочки поставок',
      role: 'Роль',
      actorIdentificationNr: 'Идентификационный номер',
      addNewActor: 'Новый участник',
      addRow: 'Новая строка',
      addHouseConsignment: 'Добавить накладную',
      addGoodsItem: 'Добавить товарную позицию',
      houseConsignment: 'Накладная',
      grossMass: 'Полная масса',
      netMass: 'Масса нетто',
      referenceNumberUCR: 'Справочный номер/UCR',
      transportChargesMethodOfPayment: 'Способ оплаты транспортных расходов',
      descriptionOfGoods: 'Описание товаров',
      commodityCode: 'Код товара',
      houseConsignmentReference: 'House consignment reference',
      numberOfPackages: 'Количество упаковок',
      goodsData: 'Данные о товарах',
      commodityDescriptionOfGoods: 'Товарное описание товара',
      commodityHarmonizedSystemSubHeadingCode: 'Код подзаголовка Гармонизированной системы',
      commodityCombinedNomenclatureCode: 'Комбинированный номенклатурный код',
      commodityCodeSearch: 'Введите для поиска…',
      goodsMeasureGrossMass: 'Полная масса',
      goodsMeasureNetMass: 'Масса нетто',
      countryOfDispatch: 'Страна отправки',
      countryOfDestination: 'Страна назначения',
      dangerousGoods: 'Опасные грузы',
      addNewGoodsItem: 'Новый товар',
      packages: 'Пакеты',
      packages_singular: 'Паковка',
      packaging: 'Пакеты',
      typeOfPackages: 'Тип упаковки',
      shippingMarks: 'Маркировочные знаки',
      addNewPackage: 'Новый пакет',
      unNumber: 'Номер ООН',
      dropzoneDescription: 'Перетащите файлы сюда или нажмите, чтобы выбрать файлы',
      files: 'Файлы',
      generalInformation: 'Общая информация',
      warnings: 'Предупреждения',
      declarationTypeSpecified: 'Указанный тип объявления',
      customsOfficeOfRouting: 'таможня маршрута',
      customsDebt: 'Таможенный долг',
      aeoDiscount: 'AEO скидка',
      numberOfItemsDeclaration: 'Количество предметов',
      dueDate: 'Срок оплаты',
      barriers: 'Барьеры',
      noWarnings: 'Нет предупреждений',
      createNew: 'Создать новый транзит',
      createNewWarning: 'Вы уверены, что хотите создать новый? Все несохраненные изменения будут потеряны.',
      unsavedChangesLostWarning: 'Все несохраненные изменения будут потеряны!!',
      upload_error: 'Загрузка файла не удалась!!',
      contactForm: 'Контактная форма Финляндии',
      notification: 'Уведомление',
      notificationDescription: 'Описание уведомления',
      notificationReason: 'Причина обращения',
      // ToDo: Correct RU translation
      houseNumber: 'номер дома',
      finlandCustomsRequestResponse: 'Ответ таможни Финляндии на запрос(FI046A)',
      agreeWithCustoms: 'Согласны ли вы с решением таможни?',
      requestRelease_title: 'Освободить транзит?',
      requestRelease: 'Незначительные несоответствия, обнаруженные во время контроля, следует ли в любом случае запрашивать разрешение на транзит?',
      duplicate: 'Копировать',
      createTransitFromEns: 'Создать транзит из ENS',
      goodsIssues: 'Товары с проблемами',
      nonArrivedMovementRelease_title: 'Запрос о не прибывших перемещениях',
      nonArrivedMovementRelease: 'Предоставьте информацию о транзитном движении, почему оно не прибыло в заявленный пункт назначения в ожидаемые сроки.',
      nonArrivedMovementRelease_explanation: 'Информация о не прибывших транзитных перевозках',
      errors: {
        title: 'Ошибки',
        none: 'Нет ошибок',
        invalidGrossMass: 'Недопустимая масса брутто в целом. ({{rootGrossMass}}) не равен массе брутто предмета ({{itemGrossMass}})',
        grossMassDifference: 'Массы брутто разные. Ожидаемая: {{expected}}, фактическая: {{actual}}',
        grossMassDifference_houseConsignment: 'SОбщая масса некоторых отправлений, доставленных на дом, меньше суммы их общей массы.',
        maximumNumberOfItemsExceeded: 'Максимальное количество ({{max}}) товаров превышено.',
      },
      typeToSearch: 'Введите текст для поиска или добавьте новый',
      prefixSearchHint: 'Поиск по началу названия. Введите 3 символа, чтобы искать по всему названию.',
      goodsSidebar: {
        title: 'House consignment no. {{houseConsignmentSequenceNumber}} goods',
      },
      houseConsignmentDrawer: {
        title: 'House consignment no. {{houseConsignmentSequenceNumber}}',
        editTitle: 'Редактирование данных субпартии',
        transitParties: 'Участники транзита',
        documents: 'Документы',
        transportation: 'Транспортировка',
        sellerAndBuyer: 'Продавец и покупатель',
      },
      consignmentItemDrawer: {
        title: 'House consignment no. {{houseConsignmentSequenceNumber}} — goods no. {{consignmentItemSequenceNumber}}',
        documents: 'Документы',
        transportation: 'Транспортировка',
        additional: 'Дополнительно',
      },
      goodsWithNumber: 'Товары ({{numberOfGoods}})',
    },
    type: 'Тип декларации',
    place: 'Место декларации',
    specialConditions: 'Особые условия',
    securityReferenceNumber: 'Особые условия',
    shipmentNumber: 'Номер отправления',
    security: 'Защитные данные',
    packagesCount: 'Кол-во упаковки',
    totalGrossMass: 'Общий вес',
    dispatchCountry: 'Страна отправления',
    destinationCountry: 'Страна назначения',
    loadingPlace: 'Место загрузки',
    unloadingPlace: 'Место выгрузки',
    transitCountries: 'Страны пересечения',
    guaranteeAmount: 'Сумма гарантии',
    nctsProfile: 'Гарантийный профиль',
    sanctionedCode: 'HS-коды под санкциями',
    blacklisted: 'Предупреждение о черном списке',
    blacklistWarning: 'Номер торговца или грузовика находится в нашем черном списке за контрабанду незаконных товаров.',
    sanctionWarning: 'Один или несколько HS-кодов могут быть под санкциями, пожалуйста, проверьте их',
    createdBy: 'Создано',
    created: 'Дата создания',
    modified: 'Дата изменения',
    goodsTradersEnabled: 'Разные отправители/получатели',
    multipleGoodsTraders: 'Множественный, набор под товар',
    consignor: 'Отправитель',
    consignee: 'Получатель',
    carrier: 'Перевозчик',
    address: 'Адрес',
    departureTruckNo: 'Номер авто на загрузке',
    departureNationality: 'Страна авто на загрузке',
    borderCrosserTruckNo: 'Номер авто на границе',
    borderCrosserNationality: 'Страна авто на границе',
    indicatorContainerised: 'Контейнер',
    containerNumber: 'Номер контейнера',
    borderTransportMode: 'Тип транспорта на границе',
    inlandTransportMode: 'Внутренний тип транспорта',
    departureCustomsOffice: 'Код таможни отправления',
    destinationCustomsOffice: 'Код таможни назначения',
    transitCustomsOffice: 'Таможни транзита',
    eoriId: 'EU ЕОРИ',
    reassignOwner: 'Переназначить владельца',
    currentOwner: 'Текущий владелец',
    selectNewOwner: 'Выберите нового владельца',
    lvGuarantee: 'Калькулятор гарантии LV / LT',
    ltGuarantee: 'Калькулятор гарантии LT',
    plGuarantee: 'Калькулятор гарантии PL',
    eeGuarantee: 'Калькулятор гарантии EE',
    latestCustomsUpdate: 'Последнее таможенное обновление',
    transitDateLimit: 'Ограничение по дате',
    numberOfGoods: 'Количество товаров',
    loadingTime: 'Дата и время загрузки',
    goodsLocation: 'Местонахождение товара',
    warehouseLocation: 'Идентификатор склада',
    goodsLocationQualifier: 'Классификатор местоположения товара',
    seal: 'Печать',
    trader: 'Трейдер',
    truck: 'Грузовик с номером',
    ens: {
      created: 'Создана новая декларация ENS',
    },
    transit: {
      created: 'Создана новая транзитная декларация.',
    },
  },
  goodsItem: {
    quantity: 'Количество',
    kindOfPackage: 'Единица количества',
    marksAndNumbers: 'Пометки и числа',
    description: 'Описание товара',
    numberOfPieces: 'Кол-во штук',
    numberOfPackages: 'Кол-во упаковок',
    hsCode: 'Код товара',
    hsCodeAudit: 'HS-код требует аудита',
    goodsItemPrice: 'Цена товара',
    goodsItemPrice_unit: 'EUR',
    price: '$t(declaration.p5.goodsItemPrice)', // for automatic csv import mapping
    goodsItemDutyRate: 'Ставка пошлины',
    goodsItemDutyRate_unit: '%',
    dutyRate: '$t(declaration.p5.goodsItemDutyRate)',
    goodsItemVatRate: 'НДС',
    goodsItemVatRate_unit: '%',
    vatRate: '$t(declaration.p5.goodsItemVatRate)',
    goodsItemExcise: 'Акциз',
    goodsItemExcise_unit: 'EUR',
    grossWeight: 'Брутто вес',
    netWeight: 'Вес нетто',
    dispatchCountry: 'Страна отправления',
    destinationCountry: 'Страна назначения',
    documents: 'Сопроводительные документы (44A)',
    documentType: 'Тип документа (44A)',
    documentNumber: 'Номер документа',
    previousDocument: 'Предыдущий документ',
    previousDocumentType: 'Тип документа (40A)',
    previousDocumentProcedure: 'Тип процедуры (40AB)',
    previousDocumentNumber: 'Номер документа (40B)',
    previousDocumentOrderNumber: 'Порядковый номер',
    documentTypeNumeric: '44A',
    previousDocumentProcedureNumeric: '40AB',
    previousDocumentTypeNumeric: '40A',
    previousDocumentNumberNumeric: '40B',
    packageUnitPlaceholder: 'Выберите единицу упаковки',
    marksPlaceholder: 'Пометки',
    descriptionPlaceholder: 'Описание товара',
    hsCodePlaceholder: 'Код',
    dispatchCountryPlaceholder: 'Выберите отправление',
    destinationCountryPlaceholder: 'Выберите назначение',
    houseNumber: 'Номер дома',
  },
  tooltips: {
    transportDocumentReference: 'Генерируется автоматически для уникальности — ENS отклоняет повторяющиеся номера транспортных документов в ICS2. Замените на ваш реальный номер CMR, если он есть.',
    security: 'Данные безопасности должны быть внесены в общие данные если есть хотябы один\n '
      + 'защищенный отправитель для всего отправления',
    goodsTraders: 'Если товары имеют разных отправителей и получателей, '
      + 'данные о грузоотправителе/грузополучателе должны быть указаны в товарах',
    deleteUser: 'Удалить/Архивировать пользователя',
    enableAccount: 'Включить пользователя',
    blockUser: 'Заблокировать пользователя',
    passwordReset: 'Отправить электронное письмо для сброса пароля',
    editDetails: 'Изменить данные',
    confirmationEmail: 'Отправить электронное письмо с подтверждением учетной записи',
    // eslint-disable-next-line max-len
    declarationCancelExplanation: 'Декларация может быть аннулирована только тогда, когда: ',
    declarationCancelExplanation_row1: 'декларация имеет MRN и',
    declarationCancelExplanation_row2: 'транзитная декларация не открыта на таможне',
    declarationCancelExplanation_row3: 'Аннулирование НЕ МОЖЕТ быть отозвано и повторно представлено таможне',
    localReject: 'Отклонить локально',
    pdfExplanation: 'Отправляет декларацию в формате PDF в виде вложения электронной почты',
    warehouse: 'Создайте идентификатор склада вашей компании как\n'
      + 'следует: код страны, собственный код y компании и расширение R (пример FI1234567-8R0001)',
    warehouseEori: 'The EORI of the operator, in the case of a place approved by Customs, is entered. If goods are to be inspected in a warehouse, the warehouse identifier shall be in the form EORI+3+2.',
    typeOfLocation: 'Select A as type of location if the goods are at the customs office of departure, B if the goods are in a warehouse'
      + ' approved by Customs, C if the goods are in a place approved by Customs, and D - Other if the goods are is some other location.',
    simplified: 'Обязательное поле в упрощенной процедуре (L). Не используется в обычной процедуре',
    loading: 'Введите дату и время, когда происходит погрузка и товар может быть осмотрен. Данные должны быть введены, если введено согласованное местонахождение товара.',
    guaranteeProfileMissing: 'Выберите профиль гарантии, чтобы продолжить',
  },
  traders: {
    title: 'Контрагенты',
    filterPlaceholder: 'Фильтр по названию',
    name: 'Название',
    identificationNumber: 'Идентификационный номер',
    address: 'Адрес',
    addressLine: 'Адресная строка',
    street: 'Улица',
    streetNumber: 'Номер дома',
    city: 'Город',
    postcode: 'Индекс',
    country: 'Страна',
    contactPerson: 'Контактное лицо',
    lastUsedAt: 'Последнее использование',
    actionFailed: 'Действие не выполнено. Обновите страницу и попробуйте снова.',
    invalidEmail: 'Введите корректный адрес эл. почты.',
    email: 'Эл. почта',
    telephone: 'Телефон',
    actions: 'Действия',
    editTitle: 'Изменить контрагента',
    identityRequired: 'Укажите название или идентификационный номер.',
    confirmDelete: 'Удалить {{name}} из контрагентов? Уже созданные декларации не изменятся.',
    empty: 'Контрагенты не найдены.',
    addressWithSecurity: 'Защитные данные',
    addressWithoutSecurity: 'Без защитных данных',
  },
  news: {
    newBadge: 'Новое',
    loadMore: 'Показать ещё',
    deleteConfirm: 'Удалить эту новость?',
    pin: 'Закрепить',
    unpin: 'Открепить',
    pinned: 'Закреплено',
    addTitle: 'Добавить новость',
    editTitle: 'Редактировать новость',
    postTitle: 'Заголовок',
    empty: 'Новостей пока нет.',
    loadFailed: 'Не удалось загрузить ленту новостей.',
    retry: 'Повторить',
    errorInvalid: 'Не удалось сохранить новость. Проверьте заголовок и содержание.',
    errorForbidden: 'У вас нет прав на управление новостями.',
    errorNotFound: 'Этой новости больше не существует.',
    errorGeneric: 'Не удалось выполнить действие. Попробуйте ещё раз.',
    copyLink: 'Скопировать ссылку на новость',
    linkCopied: 'Ссылка скопирована',
    postNotAvailable: 'Эта новость недоступна.',
    loadMoreFailed: 'Не удалось загрузить больше новостей. Попробуйте ещё раз.',
    attachments: 'Вложения',
    downloadAttachment: 'Скачать вложение',
    attachment_tooLarge: 'Файл слишком большой. Ограничение — {{maxBytes}} байт.',
    attachment_nameTooLong: 'Имя файла слишком длинное. Ограничение — {{maxLength}} символов.',
    attachment_forbiddenType: 'Файл такого типа нельзя прикрепить: SVG, HTML и программные файлы запрещены.',
    attachment_empty: 'Файл пустой.',
    attachment_nameBlank: 'У файла нет допустимого имени.',
    attachment_limitReached: 'К новости можно прикрепить не более {{max}} вложений.',
    attachment_rejected: 'Сервер не принял этот файл.',
    attachment_uploadFailed: 'Не удалось загрузить этот файл. Сохраните снова, чтобы повторить.',
    attachmentRejectedFor: 'Сервер не принял файл {{filename}}.',
    attachmentUploadFailedFor: 'Не удалось загрузить файл {{filename}}.',
    uploadsStopConfirm: 'Файлы ещё загружаются. Закрытие остановит оставшиеся загрузки. Всё равно закрыть?',
    postSaved: 'Новость сохранена.',
    downloadFailed: 'Не удалось скачать вложение.',
    notifyByEmail: 'Уведомить клиентов по e-mail',
    notifyConfirm: 'Отправить клиентам e-mail уведомление о новой новости? Это действие нельзя отменить.',
    notifyQueued: 'E-mail уведомление поставлено в очередь на отправку.',
  },
  pages: {
    page_transits: 'Транзиты П4',
    page_customers: 'Клиенты',
    page_settings: 'Настройки',
    page_traders: 'Контрагенты',
    page_news: 'Новости',
    page_restrictions: 'Ограничения',
    page_audit: 'Аудит',
    page_company: 'Компания',
    page_privacy: 'Политика конфиденциальности',
    page_notification: 'Уведомления',
    page_seo: 'SEO',
    page_customs: 'таможенная конфигурация',
    page_codelist: 'список кодов',
    page_certificates: 'Сертификаты',
    'page_transit-operations': 'транзит',
    'page_transit-audit': 'транзитный аудит',
  },
  customers: {
    title: 'Клиенты',
    customer_new: 'Новый клиент',
    customer_edit: 'Редактировать клиента',
    companyInfo: 'Информация о кампании',
    customsProfile: 'Гарантийный профиль',
    registryCode: 'Регистрационный номер',
    address: 'Адрес',
    users: 'Пользователи',
    accessCode: 'Код доступа',
    maxGuaranteeAmount: 'Максимальная сумма гарантии',
    auditRequiredAmount: 'Требуемая сумма аудита',
    guaranteeFormula: 'Формула гарантии',
    notes: 'Заметки',
    notificationEmails: 'Электронные адреса для уведомлений',
    notificationEmailsHint: 'По одному адресу на строку. На эти адреса приходят уведомления о статусе транзита.',
    status_ACCEPTED: 'АКЦЕПТИРОВАН',
    status_ACTIVE: 'АКТИВНЫЙ',
    status_BLOCKED: 'ЗАБЛОКИРОВАН',
    status_ARCHIVED: 'АРХИВИРОВАН',
    status_INACTIVE: 'НЕАКТИВНЫЙ',
    documentFilesRequired: 'Требуется загрузка документа',
    requiresAudit: 'Требуется ли пользователю аудит',
    companyName: 'Название компании',
    companyNameExample: 'Название компании должно точно совпадать с зарегистрированным EORI.',
    companyZipCode: 'Почтовый индекс компании',
    companyZipCodeExample: 'Почтовый индекс компании должен точно совпадать с зарегистрированным EORI.',
    companyStreet: 'Компания Улица',
    companyStreetExample: 'Улица компании должна точно совпадать с зарегистрированным EORI.',
    companyCity: 'Компания Город',
    companyCityExample: 'Город компании должен точно соответствовать зарегистрированному EORI.',
    companyCountry: 'Страна компании',
    streetExample: 'Адрес компании должен точно совпадать с зарегистрированным EORI.',
    companyContactEmail: 'Электронная почта компании',
    deleted: 'Дата удаления',
    lastLogin: 'Дата входа',
    directoClientCode: 'Directo клиентский код',
    apiTokenAccess: 'Доступ к клиентскому API',
    apiTokenAccessForbidden: 'Отсутствует доступ. Контактная поддержка',
    generateApiToken: 'Создать токен API',
    apiTokenActions: 'Действия токена API',
    generateApiToken_description: 'Создайте новый токен доступа к клиентскому API. Существующий токен будет отозван. Новый токен будет показан здесь только один раз во время создания. Надежно сохраните токен перед закрытием модального окна. Для аутентификации требуется токен с регистром компании. код.',
    copilotAccess: 'Доступ к Copilot',
    copilotSettings: 'Настройки Copilot',
    copilotApiToken: 'Ключ API Anthropic',
    copilotNoKeyInstalled: 'Ключ не установлен. Чат этого клиента перестанет работать.',
    copilotKeyUnreadable: 'Не удалось прочитать установленный ключ. Сохраните новый ключ или сохраните с пустым полем, чтобы удалить его.',
    copilotLoadFailed: 'Не удалось загрузить настройки Copilot. Вы всё равно можете задать состояние и установить ключ, но сохранение с пустым полем удалит ключ, который уже есть у этого клиента.',
    copilotNotFound: 'Клиент не найден.',
    copilotForbidden: 'У вас нет прав для управления настройками Copilot.',
    copilotSaveFailed: 'Не удалось сохранить настройки Copilot.',
    copilotSaved: 'Настройки Copilot сохранены',
    apiDocs: 'Сохранить спецификацию API',
    id: 'ID',
    modified: 'Изменено',
    external: 'Directo',
    giveAccess: 'Дайте доступ к профилю T1',
    publicDeclaration: 'Гарантия Т1',
    searchUsingName: 'Поиск по имени',
    searchForInput: 'Найдите «{{input}}»',
  },
  certificates: {
    expiry: 'Срок действия',
    validFrom: 'Срок действия с',
    validTo: 'Действителен до',
    name: 'Имя',
    subject: 'Subject',
    issuer: 'Эмитент',
    fingerprint: 'Fingerprint',
    showDetails: 'Показать данные сертификата',
  },
  user: {
    firstName: 'Имя',
    lastName: 'Фамилия',
    userProfileDetails: 'Детали профиля пользователя',
    password_current: 'Текущий пароль $t(common.password)',
    password_new: 'Новый пароль $t(common.password)',
    password_repeat: 'Повторить новый пароль $t(common.password)',
    accountCreationSetPassword: 'Новый пароль',
    accountCreationCreatePassword: 'Создать пароль для пользователя',
    phone: 'Телефонный номер',
    privacyPolicy: 'Я прочитал и согласен с ',
    privacy: 'Политика конфиденциальности',
    otp: 'Одноразовый пароль',
    preferences: 'Ваши предпочтения в таблице общественного транспорта',
  },
  messages: {
    confirmation: 'Вы уверены?',
    confirmSaving: 'Вы уверены, что хотите сохранить изменения?',
    maxLength: 'Имя слишком длинное. Максимальная длина: ',
    noGoodsItemsAdded: 'Ничего не добавлено',
    confirmSubmissionText: 'Подтвердить, отправку декларации',
    invalidSubmissionText: 'Пожалуйста, проверьте, что все обязательные поля заполнены:',
    successfulCancellation: 'Декларация отменена',
    nctsSubmitError: 'Ошибка при подачи декларации в таможню',
    nctsValidationError: '{{count}} ошибка валидации, декларация не отправлена',
    nctsValidationError_plural: '{{count}} ошибка валидации, декларация не отправлена',
    nctsFormInvalid: 'При подаче аннулирования декларации на таможню произошли ошибки',
    invalidField: 'Неверное поле',
    loadingGoodsItemTradersError: 'Внимание! Произошла ошибка загрузки товарной позиции',
    transitOperationsLoadFailed: 'Не удалось загрузить транзиты',
    invalidGuaranteeAmount: 'Сумма гарантии недействительна',
    blankTotalGrossMass: 'Поле общего веса товара не должно быть пустым',
    blankPackagesCount: 'Поле упаковки не может быть пустым ',
    missingTransitCountry: 'Страны пересечения не могут быть пустыми',
    missingDepartureTrailerSeparator: 'Выезд грузовик должен использовать ; как разделитель для прицепа',
    missingDestinationTrailerSeparator: 'Пограничный грузовик должен использовать ; как разделитель для прицепа',
    missingContainerNumbers: 'Отсутствует номер контейнера',
    missingGoodsDocuments: 'Отсутствуют необходимые документы для товаров',
    missingGoodsDocumentInfo: 'Отсутствует необходимый документ в позиции номер.',
    missingGoodsInfo: 'Отсутствует необходимая информация о товарк в позиции номер.',
    r105Invalid: 'Правило 105: Заявленное количество товаров ({{0}}) в декларации не соответствует количеству добавленных товаров ({{1}}) ',
    formInvalid: 'Форма недействительна',
    recoverySent: 'Письмо для восстановления отправлено',
    recoverySendingFailed: 'Не удалось отправить резервное письмо',
    customerEdit_successful: 'Успешно изменены статусы клиента и его пользователей',
    customerEdit_failed: 'Не удалось изменить статус клиента',
    customerUsersError: 'Не удалось получить пользователей клиента',
    missingRequiredFields: 'Отсутствуют обязательные поля',
    missingRequiredNameOrRegCodeFields: 'Отсутствует необходимое имя или регистрационный код',
    savingFailed: 'Не удалось сохранить',
    savingSuccess: 'Сохранено',
    inviteSent: 'Приглашение отправлено!',
    delete_successful: 'Удалено!',
    delete_failed: 'Не удалось удалить',
    duplicate_successful: '`Дубликат создан с ИД {{id}} ',
    duplicate_failed: 'Не удалось создать дубликат',
    passwordChangeLogoutWarning: 'Смена пароля приведет к обязательному выходу из системы',
    activationUrlError: 'URL активации недействителен',
    passwordsChanged_successful: 'Пароль успешно изменен. Выйти через 3 секунды… ',
    passwordsChanged_failed: 'Произошла ошибка при попытке изменить пароль',
    passwordsMatchError: 'Пароли не соответствуют',
    passwordsLengthError: 'Пароль должен состоять не менее чем из 7 символов.',
    passwordsLetterError: 'Пароль должен содержать хотя бы одну - букву большого регистра, маленького регистра и цифру.',
    invalidUrlError: 'Неправильный url',
    accountActivationError: 'Не удалось активировать аккаунт',
    exchangeRateUnavailable: 'Курс валюты для {{currency}} недоступен. Повторите попытку позже.',
    requiredGoodsDocumentsNotUploaded: 'Как минимум на одну товарную позицию должны быть документы типа N730 и N380/N325/NZZZ с файлами.',
    requiredGoodsDocumentsNotUploaded_consignmentItem: 'Для товарной позиции [{{0}}] требуются документы типов N730 и N380/N325/NZZZ, к которым прикреплены файлы.',
    duplicateDocumentsMessage: 'Желаете ли вы скопировать декларацию вместе с документами?',
    deleteConfirmMessage: 'Вы уверены, что хотите удалить строку \'{{0}}\' ?',
    download_starting: 'Начинаем скачивание…',
    emailInvalid: 'Этот формат электронной почты недействителен',
    customerSupport: 'Компания с таким кодом реестра уже существует. Обратитесь в службу поддержки: t1@tardek.com',
    eoriHelper: 'Это поле предназначено для автозаполнения полей ниже и не является обязательным.',
    accountRegisteredFirstParagraph: 'Аккаунт успешно зарегистрирован.',
    // eslint-disable-next-line max-len
    checkEmail: 'Мы отправили вам электронное письмо, чтобы подтвердить вашу информацию. Если вы не получили электронное письмо, проверьте папку со спамом.',
    userDeleted: 'Пользователь успешно удален',
    profileUpdated: 'Профиль пользователя обновлен',
    profileUpdateFailed: 'Не удалось обновить профиль пользователя',
    eoriSearchFailed: 'Убедитесь, что ваш EORI ID действителен.',
    emailInUse: 'Эта электронная почта уже зарегистрирована',
    download_manual: 'Нажмите здесь, если загрузка не началась',
    popupsBlocked: 'Перенаправления заблокированы браузером, разрешите всплывающие окна для этого сайта продолжать',
    archivedCommodityCodes: 'Обнаружен архивный код в одной из товарных позиций, обновите код до актуальной номенклатуры',
    noMatches: 'Нет совпадений',
    noOfficeResults: 'Нет результатов! Офисы ограничены правилами и должны иметь соответствующие роли. Проверка ролей на europa.eu -',
    noOfficeResults_viaRefNum: 'через ссылочный номер "{{input}}"',
    noOfficeResults_viaUsualName: 'через обычное имя "{{input}}"',
    directoAddendumWithoutCustomer: 'Directo дополнение к описанию добавлено, но клиент не указан',
    accessCodeInvalid: 'Неверный код доступа',
    profileEmpty: 'Гарантия Профиль пуст!',
    bothLanguages: 'Пожалуйста, отредактируйте оба языка!',
    goodsItemError: 'Пожалуйста, проверьте свои HS-коды для товаров!',
    declarationStatus: 'Обновление статуса декларации',
    declarationStatusChange: 'Вы собираетесь изменить статус. Это означает, что вы не можете редактировать/обновлять этот Транзит.',
    emailsEmpty: 'Пожалуйста, добавьте хотя бы одно электронное письмо!',
    notFoundError: '{{entity}} с {{field}}: {{value}} не найдено',
    goodsLocationError: 'Местоположение товара не может быть пустым!',
    goodsLocationQualifierError: 'Классификатор местоположения товара не может быть пустым!',
    useGUAFormulaPlaceholder: 'Используйте «GUA» для обозначения суммы гарантии',
    forbiddenCharacter: '{{0}} содержит кириллические символы!',
    // eslint-disable-next-line max-len
    restrictedGoods: 'Ваша декларация содержит 1 или более товарных позиций, на которые распространяются ограничения. Либо измените свой гарантийный профиль, либо измените код ТН ВЭД для товарных позиций с красной рамкой.',
    restrictedUsage_trader: 'Обнаружено использование проблемного трейдера. Вы уверены, что хотите продолжить?',
    restrictedUsage_truck: 'Обнаружено использование проблемного транспортного средства/грузовика. Вы уверены, что хотите продолжить?',
    // eslint-disable-next-line max-len
    invalidQuantityUnit: '{{type}} является недопустимым типом единицы измерения количества! Пожалуйста, проверьте Товар с номером {{number}}. Пожалуйста, повторно выберите единицу количества для товара с номером позиции {{number}}',
    // eslint-disable-next-line max-len
    destinationCountryWrong: '{{value}} недействительна Страна назначения для Товарной позиции с номером заказа {{number}}. Пожалуйста, выберите его повторно или обратитесь в службу поддержки!',
    // eslint-disable-next-line max-len
    dispatchCountryWrong: '{{value}} недействительна страна отправки для товара с номером заказа {{number}}. Пожалуйста, выберите его повторно или обратитесь в службу поддержки!',
    blacklistedWarning: '{{name}} {{field}} подозревается в контрабанде запрещенных товаров.',
    goodsItemConsignment: 'Товар(ы) отсутствует {{consignment}}',
    confirmConsentUpdate: 'Подтвердить отправку нового согласия в Borica B-Trust? Его необходимо принять в мобильном приложении B-Trust',
    guaranteeStatus: 'Transit guarantee booking is in unknown state',
    guaranteeStatus_BOOKED: 'Транзитная декларация открыта, выгружать нельзя.',
    guaranteeStatus_CREDITED: 'Прибытие принято и разгрузка разрешена',
    guaranteeStatus_CANCELLED: 'Отменена',
    guaranteeStatus_RELEASED: 'Транзитная декларация завершена',
    otpRequired: 'Проверьте свою электронную почту, там вы найдете одноразовый пароль для продолжения входа в систему.',
  },
  transitOperation: {
    ensPresentationNotification: {
      assessmentWarning: {
        title: 'оценка рисков не готова',
        message: 'Мы не получили уведомление о завершении оценки (IE3N03) для этой ENS. Отправка уведомления о презентации до завершения оценки может привести к ошибкам со стороны таможни. Вы всё равно хотите его отправить?',
        confirm: 'Всё равно отправить',
        cancel: 'Отмена',
      },
    },
    restrictionWarning: {
      title: 'Ограничения',
      restrictedGoods: 'Описание товара или HS-код соответствует ограничению',
      restrictedTrader: 'Участник соответствует ограничению',
      restrictedTruck: 'Транспортное средство соответствует ограничению',
      restrictedGoodsLabel: 'Товарные позиции',
      restrictedTraderLabel: 'Участники',
      restrictedTruckLabel: 'Транспортные средства',
      showDetails: 'Показать детали',
      confirm: 'Понятно',
    },
    draft: {
      saveSuccess: 'Черновик сохранен',
      saveError: 'Не удалось сохранить черновик',
    },
    forceCloseError: 'Не удалось закрыть транзит',
    submission: {
      sentToCustoms: 'Декларация отправлена в таможню',
      sentToReview: 'Декларация отправлена на проверку',
      awaitingSigning: 'Сообщение сформировано и ожидает подписания администратором',
      cepNotAccepted: 'CEP не принял подпись или контейнер. Подпишите декларацию заново и отправьте её повторно',
    },
    cancel: {
      requestSentToCustoms: 'Запрос на отмену отправлен в таможню',
      requestSentToReview: 'Запрос на отмену отправлен на проверку',
      modalTitle: 'Отмена декларации',
      reasonLabel: 'Причина отмены',
      defaultReason: 'Отмена запрошена пользователем',
      sentToCustomsHint: 'Это обоснование требуется таможне и направляется ей.',
      reasonInvalid: 'Обоснование должно содержать хотя бы одну букву или цифру.',
    },
  },
  houseConsignment: {
    createSuccess: 'Добавлена новая накладная',
    createError: 'Не удалось создать новую партию товаров для дома',
    saveSuccess: 'Накладная сохранена',
    saveError: 'Не удалось сохранить накладную',
    validationError: 'В форме накладной содержатся ошибки.',
  },
  errors: {
    serverError: 'Ошибка сервера! Код {{traceId}}',
    fileDownloadFailed: 'Не удалось скачать файл.',
    messageWithTraceId: '{{message}}, код: {{traceId}}',
    notBlank: 'не может быть пустым',
    notNull: 'не может быть нулевым / пустым',
    guaranteeFormula: 'оценка не удалась',
    pattern: 'Неверный формат данных',
    // eslint-disable-next-line max-len
    invalidClassifier: 'является недействительным. Невозможно извлечь классификатор. Пожалуйста, выберите его повторно или обратитесь в службу поддержки!',
    codelist: 'неверный код',
    invalidInputText: 'содержит недопустимые символы',
    unauthorized: 'Несанкционированный доступ',
    forbidden: 'Запрещенный доступ',
    notFound: 'Не найдено',
    tooManyRequests: 'Слишком много запросов',
    tooManyRequests_lockedEmail: 'Слишком много запросов, аккаунт заблокирован. Проверьте электронную почту.',
  },
  entity: {
    declaration: 'Декларация',
    customer: 'Покупатель',
    restriction: 'Ограничение',
  },
  restriction: {
    id: 'ID',
    key: 'Ключ',
    description: 'Описание',
    modified: 'Изменено',
    created: 'Созданный',
    type: 'Тип',
    commodityCodeType: 'Код товара',
    commodityDescriptionType: 'Описание',
    commoditySanctionType: 'Под санкциями',
    commodityTraderType: 'Имя трейдера',
    commodityTruckType: 'Номер грузовика',
    alreadyExists: 'Ограничение уже есть. Пожалуйста, используйте другой код/описание!',
    importSuccess: 'Импорт запущен успешно. Повторите попытку через несколько минут.',
  },
  audit: {
    id: 'Id',
    declarationId: 'Декларации ID',
    status: 'Cтатус',
    customer: 'имя покупателя',
    created: 'Созданный',
    modified: 'Изменено',
    reason: 'Причина',
    reasonForDecline: 'Причина отклонения декларации',
    submitAudit: 'Причина отклонения декларации',
    inputError: 'Причина не может быть пустой',
    updated: 'Аудит обновлен',
    error: 'Ошибка обновления аудита',
    declinationReason: 'Причина склонения',
  },
  signing: {
    title: 'Подписать и отправить декларацию',
    preparing: 'Подготовка дайджеста для подписи...',
    signingHint: 'Пожалуйста, подтвердите на устройстве подписи',
    signingWithSession: 'Подпись с использованием активной сессии...',
    submitting: 'Отправка подписанной декларации...',
    success: 'Декларация успешно подписана и отправлена',
    error: 'Ошибка подписи',
    retry: 'Повторить',
  },
  serbiaInboundFetch: {
    button: 'Получить ответы сербской таможни',
    signing: 'Подпись {{done}}/{{total}}',
    noMessages: 'Нет ожидающих ответов сербской таможни',
    resultTitle: 'Ответы сербской таможни получены',
    applied: 'Применено: {{count}}',
    alreadyApplied: 'Уже применено: {{count}}',
    noMatch: 'Нет соответствующей декларации: {{count}}',
    unreadable: 'Нечитаемые: {{count}}',
    dropped: 'Отброшено: {{count}}',
    deliverRefused: 'Отклонено шлюзом: {{count}}',
    confirmRefused: 'Подтверждение отклонено: {{count}}',
    retry: 'Ошибка, будет повторено: {{count}}',
    stillWaiting: 'Ещё ожидают: {{count}}',
    pollFailed: 'Не удалось опросить шлюз: {{reason}}',
    runOpen: 'Получение уже выполняется, повторите попытку позже',
    signingNotCompleted: 'Подпись не завершена; ничего не отправлено',
    expired: 'Время запуска истекло; ничего не отправлено',
    signaturesTooLate: 'Подписи поступили на сервер после пятиминутного лимита на подписание; ничего не отправлено',
    resultUnknown: 'Запуск завершился до получения результата; проверьте декларации перед повторной загрузкой',
    ownedByAnother: 'Запуск принадлежит другому администратору',
    forbidden: 'У вас нет прав на получение ответов сербской таможни',
    failed: 'Ошибка получения ответов сербской таможни ({{code}})',
  },
  export: {
    title: 'Экспортные транзиты',
    queueExport: 'Запросить экспорт',
    calendarFilter: 'Включенные даты',
    tutorial: 'Ссылка для скачивания на созданный файл экспорта будет отправлена по адресу \'{{0}}\'',
    customerSelect: 'Фильтр клиентов',
    declarationTypeSelect: 'Тип декларации',
    queueSubmit_success: 'Экспорт в очереди',
    queueSubmit_failed: 'Ошибка!',
    statusSelect: 'Фильтр статуса',
    dateFilter: 'Фильтр даты',
    profileFilter: 'Фильтр профиля',
  },
  eori: {
    error: 'EORI недействителен!',
    error_400: 'Ошибка! Что-то пошло не так',
    error_pattern: 'Ошибка! Проверьте шаблон, EORI должен начинаться с букв',
    error_404: 'Поиск не нашел ни одной компании',
    error_423: 'Поиск не нашел информацию о компании, часто это связано с закрытым номером EORI',
    error_500: 'Ошибка! Не удалось подключиться к поисковой системе. Если возможно, используйте проверку номера EORI на europa.eu',
    error_503: 'Ошибка! Не удалось подключиться к поисковой системе. Если возможно, используйте проверку номера EORI на europa.eu',
    error_GB: 'После выхода Великобритании из ЕС номера EORI, начинающиеся с кода «GB», не поддерживаются',
  },
  directo: {
    descriptionAddendum: 'Дополнение к описанию',
    customer: 'Клиенты',
    customerSearch: 'Ищи directo клиенты',
    remoteStaffCode: 'Directo код',
    shareProfile: 'Поделиться профилем',
    saveError: 'Не удалось сохранить событие Directo',
  },
  customsProfile: {
    profile_new: 'Добавить гарантийный профиль',
    profile_edit: 'Изменить гарантийный профиль',
    remoteStaffCode: 'Directo код',
    default: 'Сделать профиль по умолчанию',
    revoke: 'Отменить доступ',
    info: 'Дополнительная информация',
  },
  privacyPolicy: {
    editPrivacy: '$t(buttons.change) Политика конфиденциальности',
    // eslint-disable-next-line max-len
    confirm: 'Это событие потребует от всех пользователей повторного принятия политики/условий конфиденциальности. Вы уверены, что хотите обновить политику?',
    language: 'Вы редактировали оба языка?',
  },
  feedback: {
    title: 'Оставить отзыв на декларацию',
    title_canceling: 'Отменить с обратной связью',
    info: 'Информация обратной связи',
    submit: 'Отправить отзыв',
    isDeclarationCanceled: 'Отменить декларацию?',
    includePdf: 'Включить PDF',
    listOfEmails: 'Письма с обратной связью',
    listOfEmailsExplanation: 'Список адресов электронной почты, на которые должна поступать электронная почта',
    blindCopyEmail: 'Слепая копия (BCC) Электронная почта',
    // eslint-disable-next-line max-len
    blindCopyEmailExplanation: 'Адрес электронной почты, на который должна быть отправлена скрытая копия этого отзыва. Если пусто, то скрытая копия не будет отправлена',
  },
  transportCustomsOffice: {
    limit: 'Количество транзитных таможен ограничено 9',
    containsBlanks: 'Транзитные таможни не могут иметь пустых значений. Назначить таможню или удалить их',
    required: 'Требуется хотя бы одна транзитная таможня',
  },
  preferences: {
    updated: 'Настройки обновлены!',
    failed: 'Ошибка обновления настроек!',
    order: 'Список можно перетаскивать. Если вы хотите изменить порядок этого списка, щелкните имя и перетащите его в подходящее место.',
  },
  configuration: {
    alert: 'Уведомление',
  },
  notification: {
    send: 'Отправить уведомление',
    inputPlaceholder: 'Сообщение для отображения под навигацией',
    placeholder: 'Это отправит уведомление всем активным клиентам и пользователям. Ты уверен ?',
    success: 'Уведомление успешно отправлено пользователям и клиентам',
    update: 'Уведомление об обновлении',
    edit: 'Изменить/обновить уведомление',
    updateSuccess: 'Уведомление успешно обновлено!',
  },
  excel: {
    import: 'Импорт товаров',
    importGoods: 'Импорт товаров',
    save: 'Сохранить элементы',
    processingError: 'Ошибка обработки файла',
    mustBeCsv: 'Загружаемый файл должен быть в формате CSV',
    mustBeExcel: 'Загружаемый файл должен быть Excel(.xlsx)',
    invalidMimeType: 'Неподдерживаемый тип файла',
    // eslint-disable-next-line max-len
    explanation: 'Существующие позиции товаров будут перезаписаны.\n Неверные, несопоставленные или неизвестные поля будут игнорироваться.\n Формат HS-Code должен состоять из 4, 6 или 8 символов без пробелов. Пример - "4200". Код страны должен состоять из 2 символов. Пример: "RU", "EE"',
    explanationPhase5: 'Новые позиции будут добавлены в существующий список. \n  Неправильные, несопоставленные или неизвестные поля будут игнорироваться. \n  Формат HS-кода должен состоять из 6 символов. Комбинированная номенклатура (CN) при использовании должна состоять из 2 символов. Коды стран, типы и т. д. должны состоять из 2–3 символов. Пример: «ПХ», «N730».',
    missingFieldMappings: 'Некоторые столбцы без сопоставлений пропущены.',
    example: 'Скачать пример',
  },
  cookie: {
    usage: 'Продолжая использовать этот веб-сайт, вы соглашаетесь на использование файлов cookie.',
    agree: 'Соглашаться',
  },
  landing: {
    functionalities: 'Функциональность',
    integrations: 'Интеграции',
    contact: 'Контакт',
    language: 'Язык',
    languageEng: 'English',
    languageRus: 'Русский',
    heroText: 'Транзитные декларации 24/7',
    heroSubText: 'Программное обеспечение NCTS',
    heroBtnText: 'Присоединиться',
    transitDeclarationOverview: 'Обзор транзитных деклараций',
    differentCustomsProfileCreation: 'Создание таможенных профилей для разных стран',
    sendingDeclarationsForDifferentCountriesCustoms: 'Отправка деклараций в таможню разных стран',
    creatingDeclarations: 'Создание деклараций',
    declarationPDFs: 'Декларации в PDF',
    companyUserManagement: 'Управление пользователями компании',
    customsIntegrations: 'Интеграция с таможней',
    customsMapAltText: 'Интеграции',
    privacyPolicy: 'Политика конфиденциальности',
    finland: 'Финляндия',
    estonia: 'Эстония',
    latvia: 'Латвия',
    lithuania: 'Литва',
    poland: 'Польша',
    romania: 'Румыния',
    turkey: 'Ту́рция',
    germany: 'Германия',
    netherlands: 'Нидерла́нды',
    sweden: 'Шведский',
    bulgaria: 'Болга́рия',
    hungary: 'Ве́нгрия',
    greatBritain: 'Великобритания',
    greatBritain_split: 'Велико- британия',
    agreeBtn: 'Я согласен',
    termsAndConditions: 'Условия и положения',
    aboutUs: 'О нас',
    integratedModule: 'Будет создан интегрированный модуль таможенных деклараций, позволяющий заполнять таможенные декларации\n'
      + ' декларации всех стран назначения через интерфейсы через единую среду входа. С помощью модуля\n'
      + ' основной процесс Tardek OÜ автоматизирован и требует 750 рабочих часов в месяц или 9000 рабочих часов в год или примерно\n'
      + ' Экономия 180 000 евро в год. Достижение такой эффективности позволит увеличить оборот в течение двух лет\n'
      + ' после окончания проекта (2027 г.) на 80% по сравнению с 2022 г. и увеличить добавленную стоимость на одного работника более чем на 22,5%. затем'
      + ' сумма поддержки составляет 299 600 евро.',
    support: 'Tardek OÜ получила поддержку для реализации дорожной карты цифровизации\n'
      + ' из меры поддержки цифровой трансформации компаний.\n'
      + ' Сумма гранта составила 299 600 евро, проект поддержал\n'
      + ' Европейский Союз из фондов NextGenerationEU.',
    nextGenerationProject_name: 'Проект: Обеспечение бесперебойности поставок для Tardek OÜ',
    nextGenerationProject_goal: 'Цель проекта — повысить надежность поставок Tardek OÜ и снизить её зависимость от ископаемого топлива за счёт замены части потребляемой энергии возобновляемой. '
      + 'Проект поможет обеспечить круглосуточную надёжность работы компании, снизить эксплуатационные расходы и воздействие на окружающую среду.',
    nextGenerationProject_results: 'Была установлена мощная система хранения энергии, обеспечивающая бесперебойную работу в случае отключения электроэнергии. '
      + 'На крыше здания компании установлены солнечные панели, покрывающие часть потребляемой электроэнергии за счёт возобновляемой энергии. '
      + 'Существующая система отопления на дизельном топливе была заменена на электрические воздушные тепловые насосы. '
      + 'Выбросы CO₂ и расходы на электроэнергию были снижены. '
      + 'Повысилась энергетическая независимость и надёжность компании в критически важных таможенных службах.',
    nextGenerationProject_funding: 'Общая стоимость проекта составляет 248 496,00 евро, '
      + 'из которых грант составляет 90 073,20 евро, '
      + 'финансируемый Европейским Союзом из инструмента восстановления NextGenerationEU.',
  },
  seo: {
    columnTitle: 'Поисковая оптимизация',
    title: 'Заголовок сайта',
    description: 'Краткое описание',
    keywords: 'Ключевые слова, разделенные запятыми',
  },
  guaranteeCalculator: {
    preview: 'Предварительный расчет гарантии',
    pdf: 'Расчет гарантии',
    useResultValue: 'Используйте в качестве гарантии',
    totalPrice: 'Общая стоимость',
    price: 'Цена',
    excise: 'Акциз',
    dutyRate: 'Пошлины %',
    vatRate: 'НДС %',
    taxableDutyAmount: 'Облагаемые налогом пошлины',
    taxableVatAmount: 'Облагаемый НДС',
    taxableItemPrice: 'Гарантийные налоги',
  },
  consignmentItemImport: {
    header: 'Импорт консигнационного товара',
    import: 'Импортировать',
    import_start: 'Начать импорт',
    import_close: 'Закрыть импорт',
    import_success: 'Загрузка данных прошла успешно',
    import_incomplete: 'Загруженные данные неполные',
    failedWithReason: 'Импорт не удался по причине: {{reason}}',
    missingColumnMapping: 'Столбец в CSV не сопоставлен с товаром, данные могут быть неполными. - {{0}}',
    rowError_columnCount: 'Строка {{0}} недействительна. Файл сопоставлен с {{1}} столбцами. В строке есть {{2}} столбцов.',
    rowError_commodityCode: 'Строка {{0}} недействительна. Архивированный или неизвестный товарный код {{1}}',
    explanation: 'Новые позиции будут добавлены в существующий список.\n'
      + ' Неправильные, несопоставленные или неизвестные поля будут игнорироваться.\n'
      + ' Формат HS-кода должен состоять из 6 символов. Комбинированная номенклатура при использовании должна состоять из 2 символов. '
      + 'Коды стран, типы и т. д. должны состоять из 2–3 символов. Пример: «ПХ», «N730».',
    example: 'Скачать пример',
  },
  consignmentItem: {
    create_success: 'Создан товар на консигнацию',
    create_failed: 'ТСоздание отправления не удалось',
    delete_success: 'Удаленный товар с груза',
    delete_failed: 'Удаление отправления не удалось',
    duplicate_success: 'Дублированный товар на складе',
    duplicate_failed: 'Не удалось выполнить дублирование отправления',
    saveSuccess: 'Товар сохранен',
    saveError: 'Не удалось сохранить товар',
    validationError: 'В форме товарной позиции содержатся ошибки',
  },
  codelistImport: {
    title: 'Импортер кодов',
    description: 'Список кодов необходимо импортировать с помощью «RD_NCTS-P5_XX.xml» для домена NCTS-P5 или «RD_ICS2_XX.xml» для домена ICS2.',
    supportedCodeGroups: 'Группы кодов, поддерживаемые системой T1:',
    confirmImport: 'Начать импорт списков кодов? Будут добавлены новые коды, отсутствующие в файле коды будут помечены как заархивированные.',
    startImport: 'Начать импорт',
    startImport_success: 'Импорт выполнен',
    startImport_failed: 'Импорт не удался',
  },
  commodityCodesImport: {
    startImport_failed: 'Импорт не удался',
  },
  quickFilters: {
    showReleasedTransitWithLimitDateOverdue: 'Показывать открытые транзиты с просроченной датой лимита',
  },
  table: {
    deleteSelected: 'Удалить выбранное',
    deleteHouseConsignmentsConfirmation_few: 'Вы уверены, что хотите удалить {{count}} накладные?',
    deleteHouseConsignmentsConfirmation_many: 'Вы уверены, что хотите удалить {{count}} накладных?',
    deleteHouseConsignmentsConfirmation_other: 'Вы уверены, что хотите удалить {{count}} накладной?',
    deleteHouseConsignmentsConfirmation_one: 'Вы уверены, что хотите удалить накладную?',
    deletedHouseConsignments_one: 'Накладная удалена',
    deletedHouseConsignments_few: 'Удалено накладных: {{count}}',
    deletedHouseConsignments_many: 'Удалено накладных: {{count}}',
    deletedHouseConsignments_other: 'Удалено накладных: {{count}}',
    deleteConsignmentItemConfirmation_one: 'Вы уверены, что хотите удалить товар?',
    deleteConsignmentItemConfirmation_few: 'Вы уверены, что хотите удалить {{count}} товара?',
    deleteConsignmentItemConfirmation_many: 'Вы уверены, что хотите удалить {{count}} товаров?',
    deleteConsignmentItemConfirmation_other: 'Вы уверены, что хотите удалить {{count}} товара?',
    deletedConsignmentItems_one: 'Товар удалён',
    deletedConsignmentItems_few: 'Удалено товаров: {{count}}',
    deletedConsignmentItems_many: 'Удалено товаров: {{count}}',
    deletedConsignmentItems_other: 'Удалено товаров: {{count}}',
    rowsSelected: 'Выбрано записей: {{selectedCount}} из {{total}}',
  },
  datepicker: {
    today_upto: 'дней до сегодняшнего дня',
    today: 'Сегодня',
    yesterday: 'Вчера',
    week_this: 'На этой неделе',
    week_last: 'На прошлой неделе',
    month_this: 'В этом месяце',
    month_last: 'В прошлом месяце',
    year_this: 'В этом году',
    year_last: 'В прошлом году',
  },
  copilot: {
    title: 'Копилот',
    subtitle: 'Оформление транзита T1 / ENS',
    unread: 'новые обновления',
    newSession: '+ Новая',
    interrupt: 'Остановить',
    thinking: 'Думает…',
    expand: 'Развернуть панель',
    collapse: 'Свернуть панель',
    empty: {
      eyebrow: 'Новая сессия',
      headline: 'Создайте декларацию или спросите о существующей',
      hint: 'Загрузите документы по отправке — Copilot заполнит декларацию, проверит её и выполнит '
        + 'проверку по санкциям. Или спросите о декларации, уже имеющейся в Tardek. Ничего не подаётся без вас.',
      dropHint: 'Перетащите файлы, вставьте из буфера или нажмите для выбора',
      format: {
        pdf: 'PDF', image: 'Фото или скан', email: 'Письмо', sheet: 'Excel / CSV', word: 'Word',
      },
      limits: 'До 20 файлов · по 25 МБ · CMR, СМГС, счёт, упаковочный лист, письмо, Excel, Word',
      instructionLabel: 'Инструкция или вопрос',
      instructionPlaceholder: '«Создай T1 из этих документов, сначала проверь существующие черновики» '
        + 'или «почему не прошла проверка по #204938?»',
      start: 'Начать',
      startHint: 'Приложите документы для черновика или просто задайте вопрос',
    },
    confirm: {
      kicker: 'Требуется подтверждение',
      approve: 'Подтвердить',
      decline: 'Отклонить',
      reasonPlaceholder: 'Причина (необязательно)',
      sendDecline: 'Отправить отказ',
    },
    question: { portalNotice: 'Сессия завершена — продолжите в портале.' },
    turn: { you: 'Вы' },
    activity: {
      worked: 'Работа заняла',
      inProgress: 'В работе…',
      documents: 'док. прочитано',
      apiCalls: 'вызовов API',
      failed: 'Запуск не удался',
      stopped: 'Запуск остановлен',
    },
    // One key per step the copilot service reports (its `activity.STEP_LABELS`); never a path.
    step: {
      search_declarations: 'Поиск деклараций',
      read_declaration: 'Чтение декларации',
      create_declaration: 'Создание декларации',
      update_declaration: 'Изменение декларации',
      validation: 'Проверка декларации',
      customs_messages: 'Чтение таможенных сообщений',
      consignment: 'Суб-путевая накладная',
      parties: 'Участники',
      consignment_items: 'Товары',
      house_consignments: 'Накладные',
      documents: 'Документы',
      guarantee: 'Гарантия',
      reference_data: 'Справочники',
      customer_search: 'Поиск клиентов',
      exchange_rate: 'Курс валюты',
      tardek_request: 'Запрос к Tardek',
    },
    readStep: {
      document: 'Чтение {{document}}',
      reference: 'Чтение справочного файла',
    },
    error: {
      startFailed: 'Не удалось запустить сессию.',
      sendFailed: 'Не удалось отправить сообщение.',
      neverStarted: 'Эта сессия так и не запустилась, поэтому сообщение не отправлено. Начните новую сессию, чтобы попробовать снова.',
      sessionExpired: 'Копилот не смог подтвердить вашу сессию. Ваша декларация не затронута — повторите попытку, а если ошибка повторяется, войдите в систему снова.',
      confirmFailed: 'Не удалось отправить ваше решение.',
      interruptFailed: 'Не удалось остановить сессию.',
      streamLost: 'Соединение с Копилотом потеряно. Откройте панель заново, чтобы продолжить.',
      accessRevoked: 'Копилот больше не доступен для вашей организации. Ваша декларация не затронута '
        + '— свяжитесь с Tardek, если это ошибка.',
      uploadRejected: 'Копилот не смог принять эти файлы. До 20 файлов, по 25 МБ, не более 60 МБ суммарно '
        + 'и не более 200 документов за сессию.',
    },
    waiting: 'Ожидание запуска…',
    answer: { eyebrow: 'Ответ' },
    composer: {
      placeholder: 'Ответьте или добавьте инструкцию… Поддерживается Markdown.',
      send: 'Отправить',
      attach: 'Прикрепить',
      removeAttachmentNamed: 'Убрать {{name}}',
      newline: 'Shift + Enter — новая строка',
    },
    complete: {
      drafts: 'Черновики', done: 'Запуск завершён', validation: 'Проверка', cost: 'Стоимость', open: 'Открыть в редакторе',
    },
    phase: {
      empty: 'Готово к началу',
      uploading: 'Чтение документов',
      creating: 'Создание черновика',
      queued: 'В очереди',
      streaming: 'Оформление черновика',
      awaiting_confirmation: 'Нужно ваше подтверждение',
      awaiting_answer: 'Нужен ваш ответ',
      complete: 'Готово',
      error: 'Ошибка',
      interrupted: 'Остановлено',
    },
  },
}

export default TRANSLATIONS_RU

